import React, {Component} from "react"
import ButtonGroupSelect from './ButtonGroupSelect'
import {dayWeekMonthButtonGroupOptions} from '../constants'
import moment from 'moment'

export const dateRangeMap = {
  'day': {
    startDate: moment().startOf('day').subtract(6, 'days'),
    endDate: moment().endOf('day')
  },
  'week': {
    startDate: moment().startOf('week').subtract(6, 'weeks'),
    endDate: moment().endOf('day')
  },
  'month': {
    startDate: moment().startOf('month').subtract(11, 'months'),
    endDate: moment().endOf('day')
  },
}

class DayWeekMonthButtonGroupSelect extends Component {

  constructor(){
    super()
    this.state = {
      offset: 0,
      v: 'day'
    }
  }

  onSelect(v, offset){

      const {startDate, endDate} = dateRangeMap[v]
      if(_.isFunction(this.props.onSelect)){

        const offsetDate = (d)=>(d.clone().add(offset, `${v}s`))

        this.props.onSelect(v, offsetDate(startDate), offsetDate(endDate))
      }

  }

  render() {

    const offset = this.state.offset

    return (
      <div className="row" style={{width:250}}>
        <div className="col-xs-2">
          <i className="fa fa-chevron-left custom-link m-t-xs" onClick={()=>{
            const newOffset = offset-1
            this.setState({offset:newOffset})
            this.onSelect(this.state.v, newOffset)
          }}></i>
        </div>
        <div className="col-xs-2">
          <i className="fa fa-chevron-right custom-link m-t-xs" onClick={()=>{
            const newOffset = offset+1
            this.setState({offset:newOffset})
            this.onSelect(this.state.v, newOffset)
          }}></i>
        </div>

        <div className="col-xs-8">
          <ButtonGroupSelect
            onSelect={(v)=>{
              this.setState({v})
              this.onSelect(v, this.state.offset)
            }}
            options={dayWeekMonthButtonGroupOptions}
            value={this.props.value}/>
        </div>

      </div>
    )
  }
}

export default DayWeekMonthButtonGroupSelect



// WEBPACK FOOTER //
// ./src/components/DayWeekMonthButtonGroupSelect.js